export const ENTRA_ID_CLIENT = 'entra-id-client'